import acceptLanguage from 'accept-language';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import ko from 'react-intl/locale-data/ko';
import ja from 'react-intl/locale-data/ja';
import de from 'react-intl/locale-data/de';
import fr from 'react-intl/locale-data/fr';
import es from 'react-intl/locale-data/es';
import it from 'react-intl/locale-data/it';
import id from 'react-intl/locale-data/id';
import el from 'react-intl/locale-data/el';
import hu from 'react-intl/locale-data/hu';
import pl from 'react-intl/locale-data/pl';
import pt from 'react-intl/locale-data/pt';
import ru from 'react-intl/locale-data/ru';
import sk from 'react-intl/locale-data/sk';
import sl from 'react-intl/locale-data/sl';
import th from 'react-intl/locale-data/th';
import tr from 'react-intl/locale-data/tr';
import uk from 'react-intl/locale-data/uk';
import vi from 'react-intl/locale-data/vi';
import cs from 'react-intl/locale-data/cs';
import ms from 'react-intl/locale-data/ms';

import enUS from './en_US';
import zhCN from './zh_CN';
import koKr from './ko_Kr';
import zhTW from './zh_TW';
import jaJP from './ja_JP';
import deDE from './de_DE';
import frFR from './fr_FR';
import esES from './es_ES';
import itIT from './it_IT';
import idID from './id_ID';
import msMY from './ms_MY';
import elGR from './el_GR';
import huHU from './hu_HU';
import plPL from './pl_PL';
import ptPT from './pt_PT';
import ptBR from './pt_BR';
import ruRU from './ru_RU';
import skSK from './sk_SK';
import slSI from './sl_SI';
import thTH from './th_TH';
import trTR from './tr_TR';
import ukUA from './uk_UA';
import viVN from './vi_VN';
import csCZ from './cs_CZ';

addLocaleData([...en, ...zh, ...ko, ...ja, ...de, ...fr, ...es, ...it, ...id, ...el, ...hu, ...pl, ...pt, ...ru, ...sk, ...sl, ...th, ...tr, ...uk, ...vi, ...cs, ...ms]);

// deskcal 语言目录 D:\code\pc\deskcalcode\deskcal4\bin\language 共24种，以中文为基准
const LocalMap = {
    'zh': zhCN,
    'zh-tw': zhTW,
    'en': enUS,
    'ko': koKr,
    'ja': jaJP,
    'de': deDE,
    'fr': frFR,
    'es': esES,
    'it': itIT,
    'id': idID,
    'el': elGR,
    'hu': huHU,
    'pl': plPL,
    'pt': ptPT,
    'pt-BR': ptBR,
    'ru': ruRU,
    'sk': skSK,
    'sl': slSI,
    'th': thTH,
    'tr': trTR,
    'uk': ukUA,
    'vi': viVN,
    'cs': csCZ,
    'ms': msMY,
};

// deskcal 代码 -> react-intl locale
const DESKCAL_TO_LOCALE = {
    chs: 'zh', cht: 'zh-tw', usa: 'en', eng: 'en', kor: 'ko', jpn: 'ja',
    deu: 'de', fra: 'fr', esn: 'es', ita: 'it', ind: 'id', msl: 'ms',
    ell: 'el', hun: 'hu', plk: 'pl', ptb: 'pt-BR', ptg: 'pt', rus: 'ru',
    sky: 'sk', slv: 'sl', tha: 'th', trk: 'tr', ukr: 'uk', vit: 'vi', csy: 'cs',
};

// locale -> deskcal 代码（用于 getLang）
const LOCALE_TO_DESKCAL = {
    'zh': 'chs', 'zh-tw': 'cht', 'en': 'usa', 'ko': 'kor', 'ja': 'jpn',
    'de': 'deu', 'fr': 'fra', 'es': 'esn', 'it': 'ita', 'id': 'ind', 'ms': 'msl',
    'el': 'ell', 'hu': 'hun', 'pl': 'plk', 'pt': 'ptg', 'pt-BR': 'ptb', 'ru': 'rus',
    'sk': 'sky', 'sl': 'slv', 'th': 'tha', 'tr': 'trk', 'uk': 'ukr', 'vi': 'vit', 'cs': 'csy',
};

acceptLanguage.languages(Object.keys(LocalMap));

class Locale {

    static s_instance = null;

    constructor(props) {}

    static get Instance() {
        if (Locale.s_instance == null) {
            Locale.s_instance = new Locale();
        }
        return Locale.s_instance;
    }

    InitLang(lang, navigatorlanguage) {
        if (lang && DESKCAL_TO_LOCALE[lang]) {
            this.locale = DESKCAL_TO_LOCALE[lang];
        } else if (lang) {
            this.locale = 'en';
        } else {
            const detected = this.detectLocale(navigatorlanguage) || 'en';
            this.locale = LocalMap[detected] ? detected : (detected.toLowerCase().startsWith('zh-tw') ? 'zh-tw' : detected.toLowerCase().startsWith('zh') ? 'zh' : 'en');
        }
    }

    getLang() {
        return LOCALE_TO_DESKCAL[this.locale] || 'usa';
    }

    /** 用于图片资源，仅 chs/cht/kor/usa 有定制图，其余用 usa */
    getResourceLang() {
        const lang = this.getLang();
        return ['chs', 'cht', 'kor', 'usa'].includes(lang) ? lang : 'usa';
    }
    
    getLocal(){
        return this.locale;
    }

    getMessage() {
        return LocalMap[this.locale] || enUS;
    }

    getMessagebyId( id ){
        let message = this.getMessage();
        return message[id];
    }

    detectLocale(req) {
        return acceptLanguage.get( req ) || 'en';
    }
}
    

export default Locale;
